var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcAddfile = function SvgIcAddfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ic_addfile_svg__st0",
    d: "M13.1 16.1c0-3.4 3-6.2 6.4-6 .5 0 .8-.3.8-.8V7.5c0-1.2-1-2.2-2.3-2.2h-5.8c-.5 0-1.1-.2-1.4-.6l-.6-.6C9.5 3.4 8.5 3 7.6 3H2.3C1 3 0 4 0 5.2v11.6C0 18 1 19 2.3 19h10.9c.3 0 .6-.3.4-.6-.3-.7-.5-1.5-.5-2.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ic_addfile_svg__st0",
    d: "M19.1 11.1c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9S24 18.7 24 16s-2.2-4.9-4.9-4.9zm1.8 5.8h-1v1c0 .4-.4.8-.8.8s-.8-.4-.8-.8v-1h-1c-.4 0-.8-.4-.8-.8s.4-.8.8-.8h1v-1c0-.4.4-.8.8-.8s.8.4.8.8v1h1c.4 0 .8.4.8.8s-.3.8-.8.8z"
  })));
};
export default SvgIcAddfile;